import React from 'react';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { InputNumber } from 'primereact/inputnumber';
import { Panel } from 'primereact/panel';
import './restar-producto.css'

const RestarDialog = ({ visible, onHide, producto, disminuir, setDisminuir, onConfirmar }) => {
  const valor = typeof disminuir === 'number' ? disminuir : null;

  const isConfirmDisabled = 
    valor == null || Number.isNaN(valor) || valor <= 0 ||
    (producto?.stock != null && valor > Number(producto.stock));

  return (
    <Dialog 
      blockScroll
      header='Restar Existencias'
      visible={visible} 
      style={{ width: '25vw' }} 
      onHide={onHide}
      className='restar-dialog'
      footer={
        <div className='inv-btns-container'>
          <Button 
            label='Cancelar' icon="pi pi-times" 
            className='inv-btn-cancelar'
            onClick={onHide}
          />
          <Button
            label='Confirmar' icon="pi pi-check" 
            className='inv-btn-confirm'
            onClick={onConfirmar}
            disabled={ isConfirmDisabled }
          />
        </div>
      }
    >
      {producto && (
        <div className='div-restar-container'>
          <div className="div-cantidad-restar">
            <label htmlFor='restar' className='text-restar'>Restar</label>
            <InputNumber
              className='input-restar'
              id='restar'
              value={valor}
              onValueChange={(e) => setDisminuir(e.value ?? null)}
              mode='decimal'
              minFractionDigits={1}
              min={0}
              step={0.1}
              locale="es-CL"
              // max={producto?.stock ?? undefined}
              inputStyle={{ width: '100%' }}
              placeholder="0,5"
            />
            <label>{producto.unidad}</label>
          </div>

          {/* Información del producto */}
          <div className='card restar-card'>
            <Panel header='Producto'>
              <div>Producto: {producto.nombre}</div>
              <div><b>Stock Actual: {producto.stock} {producto.unidad}</b></div>
              <div>Marca: {producto.marca}</div>
              <div>Unidad: {producto.medida} {producto.unidad}</div>
              <div>Proveedor: {producto.nombreProveedor}</div>
              <div>Cantidad Actual: {producto.cantidad} </div>
            </Panel>
          </div>

        </div>
      )}
    </Dialog>
  );
};

export default RestarDialog;
